module.exports = {
          srcSet: __webpack_public_path__ + "4b1b8e5fa712d684338522b3d0f75913-90.png"+" 90w",
          images:[ {path: __webpack_public_path__ + "4b1b8e5fa712d684338522b3d0f75913-90.png",width: 90,height: 90}],
          src: __webpack_public_path__ + "4b1b8e5fa712d684338522b3d0f75913-90.png",
          toString:function(){return __webpack_public_path__ + "4b1b8e5fa712d684338522b3d0f75913-90.png"},
          
          width: 90,
          height: 90
        }